<template>
  <div class="hs-address-picker-search-bar">
    <div class="bar" @click="$emit('inputClick')" >
      <div v-if="cityLists.length <= 0" class="logo" :style="{backgroundImage: `url(${require('@/assets/image/plane-ticket/book/search.png')})`}"></div>
      <search-bar-city-lists v-if="cityLists.length > 0" :list="cityLists" @delete="_delete"/>
      <input class="disabled" maxlength="50" v-model.trim="searchTxt" :placeholder="placeholder" />
      <button v-if="cityLists.length > 0" @click.stop="$emit('confirm')">{{$t('Confirm_1')}}</button>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import SearchBarCityLists from './search-bar-city-lists'
export default {
  props: {
    cityLists: {
      type: Array,
      default: () => {
        return []
      }
    },
    placeholder: {
      type: String,
      default: ''
    },
    searchTxt: {
      type: String,
      default: ''
    }
  },
  methods: {
    _delete(i) {
      this.$emit('delete', i)
    }
  },
  components: {
    SearchBarCityLists
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.hs-address-picker-search-bar
  @extend .flex-row
  @extend .flex-center
  width 100%
  padding 5px 15px
  background-color $color_white
  >.bar
    @extend .flex-row
    @extend .flex-between
    width 100%
    border-radius 4px
    padding 3px
    background-color $color_gray_background_0
    font-size 0.9rem
    >input
      min-width calc(40% - 60px)
      width 100%
      height 29px
      font-size 0.8rem
      background-color $color_gray_background_0
    >.logo
      width 20px
      height 20px
      background-size 100% 100%
      margin-left 7px
    >button
      @extends .flex-center
      flex-shrink 0
      font-size 14px
      color $color_white
      width 60px
      height 29px
      border-radius 4px
      background $color_background_liner_theme_7
  >.close
    font-size 0.8rem
    margin-left 10px
    flex-shrink 0
</style>
